import Navbar from "./Navbar"

const Links = () => {
    return(
        <>
        <Navbar></Navbar>
        <br />
        <div className="links_container">
            <div>
                <a href=" https://www.youtube.com/@demma_98/" className="link_youtube">youtube</a>
            </div>
            <br />
            <div>
                <a href="https://demma98.itch.io/" className="link_itchio">itch.io</a>
            </div>
            <br />
            <div>
                <a href="https://www.instagram.com/demmmma_98/" className="link_instagram">instagram</a>
            </div>
            <br />
            <div>
                <a href="https://twitter.com/demma_98" className="link_twitter">twitter</a>
            </div>
            <br />
            <div>
                <a href="https://www.twitch.tv/demma98" className="link_twitch">twitch</a>
            </div>
            <br />
            <div>
                <a href="https://soundcloud.com/demma-98" className="link_soundcloud">soundcloud</a>
            </div>
            <br />
            <div>
                <a href="https://github.com/demma98" className="link_github">github</a>
            </div>
            <br />
            <div>
                <a href="https://www.reddit.com/user/demma98" className="link_reddit">reddit</a>
            </div>
            <br />
            <div>
                <a href="https://myspace.com/demma_98" className="link_myspace">myspace</a>
            </div>
            <br />
            <div>
                <a href="https://demma98.tumblr.com/" className="link_tumblr">tumblr</a>
            </div>
            <br />
        </div>
        </>
    )
}

export default Links